import React from 'react';
import LearnMore from './LearnMore';

const Card = ({
	title,
	link,
	image,
	size,
	description,
	badge,
	learnMoreDescription,
	tags,
}) => {
	const [isLearnMoreVisible, setLearnMoreVisible] = React.useState(false);

	const handleLearnMoreClick = () => {
		isLearnMoreVisible ? setLearnMoreVisible(false) : setLearnMoreVisible(true);
	};

	return (
		<div className="project-card">
			<div className="project-card-image">
				{image ? (
					<img src={image} alt={title} className={size ? 'contain' : ''} />
				) : (
					<span style={{ color: 'var(--text-muted)', fontSize: '13px' }}>
						No preview
					</span>
				)}
			</div>
			<h2 className="project-card-title">{title}</h2>
			<p className="project-card-desc">{description}</p>
			<div className="project-card-actions">
				{link && (
					<a
						href={link}
						target="_blank"
						rel="noopener noreferrer"
						className="project-btn"
					>
						Watch on YouTube ↗
					</a>
				)}
				{badge && (
					<span className="project-wip badge-animation">
						⚠️ Work In Progress
					</span>
				)}
				{
					<span
						className="project-more project-btn-outline"
						onClick={handleLearnMoreClick}
					>
						Learn More
					</span>
				}
				<LearnMore
					title={title}
					learnMoreDescription={learnMoreDescription}
					tags={tags}
					isVisible={isLearnMoreVisible}
					onClose={() => setLearnMoreVisible(false)}
				/>
			</div>
		</div>
	);
};

export default Card;
